import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Users, Plus, Trash2, Loader2 } from "lucide-react";

const inputCls = "bg-[#0A1826] border border-white/10 rounded-sm px-3 py-2 text-sm text-white focus:outline-none focus:ring-1 focus:ring-[#EA7B2B]";

export default function Operatori() {
  const [ops, setOps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ nome: "", email: "", telefono: "", qualifica: "", attivo: true });
  const [saving, setSaving] = useState(false);

  const load = () => { setLoading(true); api.get("/operatori").then((r) => setOps(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.nome.trim()) { toast.error("Nome obbligatorio"); return; }
    setSaving(true);
    try {
      await api.post("/operatori", form);
      toast.success("Operatore aggiunto");
      setForm({ nome: "", email: "", telefono: "", qualifica: "", attivo: true });
      load();
    } catch { toast.error("Errore salvataggio"); }
    finally { setSaving(false); }
  };

  const toggle = async (op) => {
    await api.patch(`/operatori/${op.id}`, { ...op, attivo: !op.attivo }).catch(() => {});
    load();
  };
  const remove = async (op) => {
    await api.delete(`/operatori/${op.id}`).catch(() => {});
    toast.success("Operatore rimosso");
    load();
  };
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <div className="space-y-6" data-testid="operatori-page">
      <div>
        <h1 className="text-3xl font-light text-white flex items-center gap-3"><Users className="w-7 h-7 text-[#EA7B2B]" /> Operatori</h1>
        <p className="text-sm text-zinc-500 mt-1">Gestione del team a cui assegnare le operazioni (CRM)</p>
      </div>

      <div className="bg-[#122A3F] border border-white/10 rounded-sm p-5" data-testid="operatore-form">
        <h2 className="text-sm font-medium text-zinc-200 uppercase tracking-wider mb-4">Nuovo operatore</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <input value={form.nome} onChange={(e) => set("nome", e.target.value)} placeholder="Nome e cognome" data-testid="operatore-nome" className={inputCls} />
          <input value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="Email" data-testid="operatore-email" className={inputCls} />
          <input value={form.telefono} onChange={(e) => set("telefono", e.target.value)} placeholder="Telefono" data-testid="operatore-telefono" className={inputCls} />
          <input value={form.qualifica} onChange={(e) => set("qualifica", e.target.value)} placeholder="Qualifica (es. Origination)" data-testid="operatore-qualifica" className={inputCls} />
        </div>
        <button onClick={add} disabled={saving} data-testid="operatore-add-btn" className="mt-4 flex items-center gap-2 bg-[#EA7B2B] text-black text-sm font-medium px-4 py-2.5 rounded-sm hover:bg-[#F59E4A] transition-colors disabled:opacity-50">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />} Aggiungi operatore
        </button>
      </div>

      <div className="bg-[#122A3F] border border-white/10 rounded-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#0A1826]/90">
            <tr className="text-left text-xs text-zinc-500 uppercase tracking-wider border-b border-white/10">
              <th className="px-5 py-3 font-medium">Nome</th>
              <th className="px-5 py-3 font-medium">Qualifica</th>
              <th className="px-5 py-3 font-medium">Contatti</th>
              <th className="px-5 py-3 font-medium">Stato</th>
              <th className="px-5 py-3 font-medium text-right">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="py-12 text-center"><Loader2 className="w-6 h-6 text-[#EA7B2B] animate-spin mx-auto" /></td></tr>}
            {!loading && ops.length === 0 && <tr><td colSpan={5} className="py-12 text-center text-zinc-500">Nessun operatore</td></tr>}
            {!loading && ops.map((op) => (
              <tr key={op.id} data-testid={`operatore-row-${op.id}`} className="border-b border-white/5">
                <td className="px-5 py-3 text-white">{op.nome}</td>
                <td className="px-5 py-3 text-zinc-400">{op.qualifica || "—"}</td>
                <td className="px-5 py-3 text-zinc-400 text-xs">{op.email || "—"}{op.telefono ? ` · ${op.telefono}` : ""}</td>
                <td className="px-5 py-3">
                  <button onClick={() => toggle(op)} data-testid={`operatore-toggle-${op.id}`} className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-sm border ${op.attivo ? "text-[#10B981] bg-[#10B981]/10 border-[#10B981]/30" : "text-zinc-500 bg-zinc-500/10 border-zinc-500/30"}`}>
                    {op.attivo ? "Attivo" : "Disattivo"}
                  </button>
                </td>
                <td className="px-5 py-3 text-right">
                  <button onClick={() => remove(op)} data-testid={`operatore-del-${op.id}`} className="text-zinc-500 hover:text-[#E11D48] transition-colors"><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
